import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PagoExito() {
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => navigate('/seleccion'), 3000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(160deg, #FFF0F5 0%, #FFE4EF 60%, #FDF2F8 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px',
    }}>
      <div className="fade-in" style={{
        background: '#FFFFFF', border: '1px solid #FBCFE8', borderRadius: '20px',
        padding: '56px 40px', textAlign: 'center', maxWidth: '440px', width: '100%',
        boxShadow: '0 16px 48px rgba(236,72,153,0.12)',
      }}>
        <div style={{ fontSize: '64px', marginBottom: '16px' }}>🎉</div>
        <h2 style={{ color: '#581C47', fontSize: '26px', marginBottom: '10px', fontFamily: 'Inter, sans-serif' }}>
          ¡Suscripción activada!
        </h2>
        <p style={{ color: '#BE84A3', fontSize: '15px', marginBottom: '28px' }}>
          Tu acceso ha sido activado correctamente. Redirigiendo...
        </p>
        <button
          onClick={() => navigate('/seleccion')}
          style={{
            background: 'linear-gradient(135deg, #EC4899 0%, #F472B6 100%)',
            border: 'none', color: '#fff', padding: '12px 28px',
            borderRadius: '50px', fontSize: '14px', fontWeight: 600, cursor: 'pointer',
            boxShadow: '0 6px 20px rgba(236,72,153,0.35)',
          }}
        >
          Ir al inicio
        </button>
      </div>
    </div>
  );
}
